import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RequirementService {

  currentRequisite;

  constructor() { }

  setCurrentRequisite(r){
    this.currentRequisite = r;
  }

  getCurrentRequisite(){
    return this.currentRequisite;
  }
}
